import { render, staticRenderFns } from "./HeaderCategories.vue?vue&type=template&id=3542ddc3&"
import script from "./HeaderCategories.vue?vue&type=script&lang=js&"
export * from "./HeaderCategories.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCategories.vue?vue&type=style&index=0&id=3542ddc3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports